import { render, staticRenderFns } from "./Catalogs.vue?vue&type=template&id=450acfd8"
import script from "./Catalogs.vue?vue&type=script&lang=js"
export * from "./Catalogs.vue?vue&type=script&lang=js"
import style0 from "./Catalogs.vue?vue&type=style&index=0&id=450acfd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports